import options from './ccon-chart.component';

export default {
    selector: 'dtCloudConnectorChart',
    options
};
